import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import SectorTable from '@sectors/components/tables/sector-table/sector-table.vue';

@Component({
  name: 'bpc-sectors',
  components: {
    'bpc-sector-table': SectorTable,
  },
})
export default class Sectors extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
